/**
 * Exporta a XLSX el Reporte de Eficiencia Terminal.
 *
 * @param {Object} params
 * @param {Array}  params.resultados  - Filas: { numero, matricula, nombre, programa, estatus }
 * @param {Object} params.contexto    - { cicloIngreso, campus, seccion, programa }
 * @param {Object} [params.resumen]   - { total, egresados, eficiencia_pct, estatus_distribucion }
 */
import * as XLSX from 'xlsx';

const COLUMNAS = [
  '#',
  'Matrícula',
  'Nombre',
  'Programa Académico',
  'Estatus',
];

function fechaArchivo() {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}_${pad(d.getHours())}${pad(d.getMinutes())}`;
}

export function exportReporteEficienciaTerminalXLS({ resultados = [], contexto = {}, resumen = null } = {}) {
  const {
    cicloIngreso = '—',
    campus = 'Todos',
    seccion = 'Todas',
    programa = 'Todos',
  } = contexto;

  const fmtPct = (v) => {
    const n = Number(v);
    return Number.isFinite(n) ? `${n} %` : '—';
  };

  const aoa = [
    ['REPORTE DE EFICIENCIA TERMINAL'],
    [`Ciclo Escolar de Ingreso: ${cicloIngreso}`],
    [`Campus: ${campus}`],
    [`Sección: ${seccion}`],
    [`Programa: ${programa}`],
    [`Generado: ${new Date().toLocaleString('es-MX')}`],
  ];

  // Indicadores del resumen ejecutivo (encabezado, nunca como columnas de la tabla).
  if (resumen) {
    aoa.push([`Porcentaje de Eficiencia Terminal: ${fmtPct(resumen.eficiencia_pct)}`]);
    aoa.push([`Total General: ${resumen.total ?? resultados.length}`]);
    const distrib = Array.isArray(resumen.estatus_distribucion) ? resumen.estatus_distribucion : [];
    if (distrib.length > 0) {
      aoa.push([]);
      aoa.push(['Distribución por estatus:']);
      distrib.forEach((e) => {
        aoa.push([`${e.label}: ${e.cantidad} (${fmtPct(e.porcentaje)})`]);
      });
    }
  } else {
    aoa.push([`Total de registros: ${resultados.length}`]);
  }

  aoa.push([]);
  aoa.push(COLUMNAS);

  resultados.forEach((r, idx) => {
    aoa.push([
      r.numero ?? (idx + 1),
      r.matricula || '',
      r.nombre || '',
      r.programa || '',
      r.estatus || '',
    ]);
  });

  const ws = XLSX.utils.aoa_to_sheet(aoa);

  ws['!cols'] = [
    { wch: 6 },
    { wch: 16 },
    { wch: 40 },
    { wch: 36 },
    { wch: 16 },
  ];

  ws['!merges'] = [
    { s: { r: 0, c: 0 }, e: { r: 0, c: COLUMNAS.length - 1 } },
  ];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Eficiencia Terminal');

  const fileName = `reporte_eficiencia_terminal_${fechaArchivo()}.xlsx`;
  XLSX.writeFile(wb, fileName);
}

export default exportReporteEficienciaTerminalXLS;
